import React, { useState, useEffect } from 'react'
import { Box, Grid, Card, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom';
import listRoutes from '../../layouts/sidebar/listRoutes.json'
import ApiService from '../../utils/ApiService';
import { useSelector, useDispatch } from 'react-redux';
import { openDialog, setData } from "../../features/dialogBox/dialogBoxSlice";
import transformationHelper from '../../utils/transformationHelper';
import { openConfirmDialog } from '../../features/confirmDialogBox/confirmDialogBoxSlice';
import { openSnackbar } from '../../features/snackbar/snackbarSlice';
import encriptionHelper from '../../utils/encriptionHelper';
import { useNavigate } from 'react-router-dom';
import SinglePostSkeleton from '../../component/CommonPage/SinglePostSkeleton'
import SinglePostPhoto from './SinglePostPhoto';
import SinglePostCard from './SinglePostCard';
import SingleComment from './SingleComment'
import Dialogs from './Dialogs';
import SingleMenu from './SingleMenu';
import SingleCommentReaction from './SingleCommentReaction';

const SinglePost = () => {
  const dispatch = useDispatch();
  // const searchParams = encriptionHelper().decryptURLParams(window.location.search.substring(1).split("&")[0].split("=")[1]);
  const [snackBar, setSnackBar] = useState({ dataLoad: false, message: '' });
  const location = useLocation()
  const searchParams = location?.state || JSON.parse(localStorage.getItem("state"));
 console.debug("singlepost: search",searchParams)
  const isAnnouncementPage = searchParams['indivisualAPI'] == "FeedAnnouncements";
  const [feedPostData, setFeedPostData] = useState((state) => state?.user?.feedPostData ?? {});
  const feedPostName = listRoutes.filter((route) => route.path == (searchParams['feedPostName'] ?? location.state?.feedPostName))?.[0]?.label ?? listRoutes.filter((route) => route.path == ((typeof searchParams['feedPostName'] != 'string') ? '/' : searchParams['feedPostName']) ?? searchParams['feedPostName'])?.[0]?.label ?? searchParams['feedPostName'];
  const indivisualAPI = searchParams['indivisualAPI'] ?? location.state?.indivisualAPI ?? 'FeedList';
  const reactPost = searchParams['reactPost'] ?? location?.reactPost ?? 'reactPost';
  const [commentText, setCommentText] = useState('');
  const [showComment, setShowComment] = useState(false);
  const [feedPostComments, setFeedPostComments] = useState(feedPostData?.comments ?? []);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state?.user?.userListName)
  const formTransform = transformationHelper().getTransformationFunction(indivisualAPI)
  const [isTextFieldFocused, setIsTextFieldFocused] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [currentCommentId, setCurrentCommentId] = useState(false);
  const navigate = useNavigate();
  const isMoreSection = ["LeaderSpeak", "FeedList", "Social", "Events"].indexOf(searchParams['indivisualAPI']) == -1;
  const showPostData = useSelector((state) => state.formData.formToSend);
  const showSetPostData = useSelector((state) => state.formData.formToUpdate);
  const [isLoadingFeedPost, setIsLoadingFeedPost] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showPicker, setShowPicker] = useState(false);
  const openEmoji = Boolean(showPicker);
  const idEmoji = openEmoji ? 'simple-popover' : undefined;

  // code will run when someone comments or give reaction
  useEffect(() => {
    if (showSetPostData) {
      console.log({ showSetPostData });
      const transformedData = formTransform(showSetPostData.formToSend);
      console.log({ transformedData });
      // console.log({ transformedData })
      setFeedPostData(transformedData);
      setAllComments(transformedData)
    }
  }, [showPostData, showSetPostData])




  const setAllComments = (data) => {
    let comment = (feedPostData.type == 'userJoining' ? data.comment : data.comments);
    comment = comment.sort((a, b) => {
      // Check if both objects have created_at field
      if (!a.created_at || !b.created_at) {
        // Keep original order if no created_at field
        return 0;
      }

      // Compare timestamps in descending order
      return new Date(b.created_at) - new Date(a.created_at);
    })
    setFeedPostComments(comment)
  }

  const getPostFeedData = () => {
    if (!userData?.userId) {
      return;
    }
    window.scroll(0, 0);
    setIsLoading(true);
    if (!feedPostData || !feedPostData.id) {
      let postFeed = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]
      ApiService.get(indivisualAPI, { userId: userData.userId }, postFeed)
        .then((res) => {
          const data = res.data.data;
          if (data) {
            const transformedData = formTransform(data);
            // console.log({ transformedData })
            setFeedPostData(transformedData);
            setAllComments(transformedData)
            // setFeedPostComments(transformedData.comments)
            setIsLoading(false);
            setIsLoadingFeedPost(true)

          } else {
            // console.error("Data is missing or not in the expected format.");
          }
        })
        .catch((error) => {
          // console.error("API request error:", error);
          setIsLoading(false);
        });
    } else {
      if (indivisualAPI) {
        ApiService.get(indivisualAPI, { userId: userData.userId }, feedPostData.id)
          .then((res) => {
            let data = [res.data.data].map(v => formTransform(v))[0];
            if (data) {
              setFeedPostData(data);
              setAllComments(data)
              // setFeedPostComments(data.comments)
              setIsLoading(false);
              setIsLoadingFeedPost(true)
            }
          })
          .catch((error) => {
            setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
            setIsLoading(false);
          });
      }

    }
    setReactionBTN();
  }

  useEffect(() => {
    getPostFeedData();
  }, [userData]);

  const getUserReaction = () => {
    // fetch last reaction index of current user if any
    let reactions = feedPostData?.post_reactions?.reduce((prev, curr) => {
      if (prev == -1 && (curr.userId == userData.userId || curr.pivot?.user_id == userData.userId)) {
        prev = [curr];
      }
      return prev;
    }, -1) ?? -1;
    if (reactions != -1) {
      reactions = JSON.parse(JSON.stringify(reactions)).map(v => { v.reactionId = v.reactionId ?? parseInt(v.pivot?.reaction_id); return v; })[0]
    }
    return reactions;
  }

  const setReactionBTN = () => {
    let findUserReaction = getUserReaction();
    if (findUserReaction != -1) {
      setSelectedOption(findUserReaction?.reactionId ?? parseInt(findUserReaction?.pivot?.reaction_id))
    } else {
      setSelectedOption(null)
    }
  }

  useEffect(() => {
    setReactionBTN();
  }, [feedPostData])

  // ------MENU DROPDOWN START ------------------

  const getCurrentMenu = (currPost) => {
    // console.log('a1', currPost, feedPostData.postSaved)
    if (currPost.userId == feedPostData.userId) {
      let currentUserMenu = feedPostData.userId == userData.userId;
      let saveOption = feedPostData.postSaved
        ? [{ type: 'Unsave', onClick: () => { handleUnsavePost(feedPostData) } }]
        : [{ type: 'Save', onClick: () => { handleSavePost(feedPostData) } }];

      let currentMenus = [...saveOption, { type: 'Copy', onClick: handleSnakbarClick }];
      if (!currentUserMenu && indivisualAPI == 'FeedList') {
        currentMenus = [
          ...currentMenus,
          { type: 'Report', onClick: () => { openReportPostClick(currPost) } },
          { type: 'Hide', onClick: () => { handleHidePost(currPost) } }
        ];
      } else if (currentUserMenu && indivisualAPI == 'FeedList') {
        currentMenus = [{ type: 'Edit', onClick: () => handleEditDialog(feedPostData) }, { type: 'Delete', onClick: () => { handleConfirmDialog('ConfirmDeletePost', feedPostData) } }, ...currentMenus]
      }

      return currentMenus;
    }
  }
  const handleSavePost = (currerntPost) => {
    let api = reactPost == 'reactPost' ? 'savePostUser' : 'saveFavoriteFeeds';
    const formData = new FormData();
    if (reactPost != 'reactPost') {
      // payload = {userId: userData.userId, type: post.type};
      if (feedPostData.type == 'reward')
        formData.append('awardUserId', feedPostData.id);
      else
        formData.append(feedPostData.type + "Id", feedPostData.id);
      formData.append('userId', userData.userId);
      formData.append('type', feedPostData.type);
    } else {
      formData.append('userId', userData.userId);
      formData.append('postId', currerntPost.id);
    }
    ApiService.postAdopter(api, formData)
      .then((response) => {
        let data = response.data.data;
        if (data) {
          dispatch(openSnackbar({ dataLoad: true, message: 'Your post has been saved successfully!', severity: "info" }));
          ApiService.get(indivisualAPI, { userId: userData.userId }, feedPostData.id).then((res) => {
            const data = [res.data.data].map(v => formTransform(v))[0];
            if (data) {
              updateReaction(data);
            }
          })
            .catch((error) => {
            })
        }
      })
      .catch((error) => {
        // Handle error
        setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
      });
    setAnchorEl(null);
  }
  const handleUnsavePost = (currerntPost) => {
    let api = reactPost == 'reactPost' ? 'unsavePostUser' : 'unsaveFavoriteFeeds';
    let payload = { userId: userData.userId, postId: currerntPost.id };
    if (reactPost != 'reactPost') {
      const formData = new FormData();
      formData.append('userId', userData.userId);
      formData.append('type', feedPostData.type);
      formData.append('postId', currerntPost.id);
      ApiService.postAdopter(api, formData)
        .then((response) => {
          dispatch(openSnackbar({ dataLoad: true, message: 'Your post has been unsaved successfully!', severity: "info" }));
          ApiService.get(indivisualAPI, { userId: userData.userId }, feedPostData.id).then((res) => {
            const data = [res.data.data].map(v => formTransform(v))[0];
            if (data) {
              updateReaction(data);
            }
          })
            .catch((error) => {
              // console.error('Error:', error);
            });
        })
        .catch((error) => {
          // console.error('Error:', error);
          setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
        });
    } else {
      ApiService.get(api, payload)
        .then((response) => {
          dispatch(openSnackbar({ dataLoad: true, message: 'Your post has been unsaved successfully!', severity: "info" }));
          ApiService.get(indivisualAPI, { userId: userData.userId }, feedPostData.id).then((res) => {
            const data = [res.data.data].map(v => formTransform(v))[0];
            if (data) {
              updateReaction(data);
            }
          })
            .catch((error) => {
              // console.error('Error:', error);
            });
        })
        .catch((error) => {
          // console.error('Error:', error);
          setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
        });
    }
    setAnchorEl(null);
  }
  const handleHidePost = (currentPost) => {
    const api = 'HiddenPost';
    const payload = {
      userId: userData.userId,
      postId: currentPost.id,
    };
    // console.log('abc', currentPost.id)
    ApiService.postAdopter(api, payload)
      .then((response) => {
        dispatch(openSnackbar({ dataLoad: true, message: 'Your post has been hidden successfully!', severity: 'info' }));
      })
      .catch((error) => {
        setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
      });
  };
  const openReportPostClick = () => {
    dispatch(openConfirmDialog('ReportPostDialog'));
  }
  const handleEditDialog = (postData) => {
    dispatch(setData(postData))
    dispatch(openDialog('editDialog'));
  }
  const handleConfirmDialog = (id, postData) => {
    dispatch(setData(postData));
    dispatch(openConfirmDialog(id));
    setAnchorEl(null);
  }
  const updateReaction = (updatedPost) => {
    // console.log({ feedPostData })
    setFeedPostData(updatedPost)
    setAllComments(updatedPost)
    // setFeedPostComments(updatedPost.comments)
  }
  const updateComment = (commentId, updatedComment) => {
    setFeedPostComments(feedPostComments.map(v => v.id == commentId ? { ...v, commentBody: updatedComment } : v))
  }
  const handleTextFieldBlur = () => {
    setShowComment(false);
  };
  const handleEmojiClick = (emojiObject) => {
    setShowPicker(emojiObject.currentTarget);
  };
  const handleEmojiClose = () => {
    setShowPicker(false);
  };
  const onEmojiClick = (event, emojiObject) => {
    setCommentText((prevInput) => prevInput + emojiObject.emoji);
    setShowPicker(false);
  };
  const handleComment = async () => {
    // if (commentText.trim() !== '') {
    //   setIsLoading(true);
    if (commentText.trim() !== '') {
      setIsLoading(true);
      const newComment = {
        userName: userData.userName,
        userAvatar: userData.userAvatar,
        commentBody: commentText,
        created_at: new Date().toISOString(),
      };
      try {
        let payload = {
          userName: userData.userName,
          userId: userData.userId,
          postId: feedPostData.id,
          commentBody: commentText,
        };
        if (reactPost != 'reactPost') {
          payload = { userId: userData?.userId, comment: commentText, commentType: feedPostData.type, status: 1 }
          payload[feedPostData.type + "Id"] = feedPostData.id;
          if (feedPostData.type == 'reward')
            payload['awardUserId'] = feedPostData.id;
          if (feedPostData.type == 'userJoining')
            payload['joiningId'] = feedPostData.id;
          if (feedPostData.type == 'userWedding')
            payload['weddingId'] = feedPostData.id;
        }
        // }
        // console.log({ reactPost })
        let api = reactPost == 'reactPost' ? 'submitComment' : 'UpdateComment';
        const response = await ApiService.post(api, payload);
        if (response.status === 200) {
          ApiService.get(indivisualAPI, { userId: userData?.userId }, feedPostData.id)
            .then((res) => {
              let data = [res.data.data].map(v => formTransform(v))[0];
              if (data) {
                setAllComments(data)
                dispatch(openSnackbar({ dataLoad: true, message: 'Your comment has been submitted successfully!', severity: 'info' }));
              }
            })

        }
      } catch (error) {
        setSnackBar({ dataLoad: true, message: 'API request failed', severity: 'error' });
      } finally {
        setIsLoading(false); // Set loading state to false after API request completes
      }
      setCommentText('');
      handleTextFieldBlur();
    }
    setAnchorEl(null);
  };
  const formattedDate = feedPostData?.created_at
    ? new Date(feedPostData.created_at).toLocaleDateString(undefined, {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    })
    : null;
  // console.log ('a1',feedPostData.created_at)

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menus, setMenus] = useState([]);

  const handleClick = (event, menus) => {
    // console.log("sfkdj", { currentTarget: event.currentTarget })
    setMenus(menus);
    setAnchorEl(event.currentTarget);
  };


  // console.log({formattedAlbum,album});
  const goBack = () => {
    window.history.back();
  }

  ///////////////////////Report Comment////////////////////////////////////////

  const reportComment = (commentId, postData) => {
    setCurrentCommentId(commentId);
    dispatch(setData(postData));
    dispatch(openConfirmDialog('ReportDialog'));
    // setFeedPostComments(feedPostComments.filter(v => v.id != commentId))
  }

  ////////

  const deleteComment = (commentId, postData) => {
    setCurrentCommentId(commentId);
    dispatch(setData(postData));
    dispatch(openConfirmDialog('ConfirmDialog'));
    setFeedPostComments(feedPostComments.filter(v => v.id != commentId))
  }


  const handleSnakbarClick = () => {
    dispatch(openSnackbar({ dataLoad: true, message: 'This is a success message!', severity: "info" }));
  };

  return (
    <Box sx={{
      minHeight: 'calc(95vh - 90px)',
      position: 'relative',
      '& .grid1, & .grid2': {
        '@media screen and (min-width: 900px)': {
          overflowY: 'auto',
          maxHeight: '100vh',
          '&::-webkit-scrollbar': {
            width: '0.5em', // Set the width of the scrollbar
            display: 'none', // Hide the scrollbar
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent', // Set the color of the thumb
          },
        }
      }
    }}>
      {isLoadingFeedPost ?
        <Grid container spacing={2}>
          <Grid className='grid1' item lg={8} md={7} sm={12} xs={12}>
            <Box sx={{ display: 'flex', color: '#2563EB', cursor: 'pointer', alignItems: 'center' }}>
              <Box sx={{ marginTop: '0.4rem' }} onClick={goBack}>
              </Box>
              {isMoreSection && (<>
                <Box sx={{ color: '#212121', '&:hover': { color: '#2563EB', } }} onClick={() => { navigate('/more') }}><Typography variant="h6">More</Typography></Box>
                <Typography px={1} variant="h6" sx={{ color: '#212121' }}>{' / '}</Typography>
              </>)}
              <Box sx={{ color: '#212121', '&:hover': { color: '#2563EB', } }} onClick={goBack}><Typography variant="h6">{isAnnouncementPage ? 'Announcements' : feedPostName}</Typography></Box>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Card>
                {/* ---------------- SINGLE POST CARD COMPONENT ------------- */}
                {/* {(feedPostData.userName && feedPostData.type != 'userBirth' && feedPostData.type != 'userWedding' && feedPostData.type != 'workAnniversary' && feedPostData.type != 'promotion' && feedPostData.type != 'reward' && feedPostData.type != 'child' && feedPostData.type != 'userJoining') && ( */}
                <Box>
                  <SinglePostCard feedPostData={feedPostData} handleClick={handleClick} getCurrentMenu={getCurrentMenu} formattedDate={formattedDate} />
                </Box>
                {/* )} */}
                {/* ----------- PHOTO AND SLIDER COMPONENT --------------- */}
                <SinglePostPhoto feedPostData={feedPostData} />

                {/* -------------- SINGLE COMMENT AND REACTION COMPONENT ---------- */}

                <SingleCommentReaction feedPostComments={feedPostComments} indivisualAPI={indivisualAPI} formTransform={formTransform} updateReaction={updateReaction} setSnackBar={setSnackBar}
                  feedPostData={feedPostData} getUserReaction={getUserReaction}
                  selectedOption={selectedOption} />
              </Card>
            </Box>
          </Grid>
          {/* -----------SINGLE COMMENT SECTION ----------- */}
          <SingleComment feedPostComments={feedPostComments} handleSnakbarClick={handleSnakbarClick} setCommentText={setCommentText} setIsTextFieldFocused={setIsTextFieldFocused} isTextFieldFocused={isTextFieldFocused}
            updateComment={updateComment} deleteComment={deleteComment} reportComment={reportComment} commentText={commentText} setShowEmoji={setShowEmoji} handleTextFieldBlur={handleTextFieldBlur} reactPost={reactPost}
            handleEmojiClick={handleEmojiClick} idEmoji={idEmoji} openEmoji={openEmoji} showPicker={showPicker} handleEmojiClose={handleEmojiClose} onEmojiClick={onEmojiClick} handleComment={handleComment} isLoading={isLoading}
          />
        </Grid>
        :
        <SinglePostSkeleton />
      }
      <SingleMenu feedPostData={feedPostData} handleUnsavePost={handleUnsavePost} setData={setData} getCurrentMenu={getCurrentMenu} setSnackBar={setSnackBar} anchorEl={anchorEl}
        handleSavePost={handleSavePost} indivisualAPI={indivisualAPI} setMenus={setMenus} setAnchorEl={setAnchorEl} handleClick={handleClick} feedPostName={feedPostName} menus={menus}
      />

      <Dialogs feedPostData={feedPostData}
        deleteComment={deleteComment} reactPost={reactPost} currentCommentId={currentCommentId} setAnchorEl={setAnchorEl} reportComment={reportComment} />
    </Box>

  )
}

export default SinglePost